import { Spinner } from "@chakra-ui/react";

export const QuestionsLoading = () => (
	<div
		className="flex items-center justify-center py-12"
		data-testid="pre-compliance-questions-loading"
	>
		<Spinner size="lg" color="blue.500" />
	</div>
);
